import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ISpreadsheets,
  ISpreadsheetsState,
} from "redux/types/spreadsheets.types";
import { getManagersList, getSpreadshitsList } from "service/api";

const ns = "spreadsheets";

const initialState: ISpreadsheetsState = {
  spreadsheets: {
    loading: false,
    error: "",
  },
  managers: {
    loading: false,
    error: "",
  }
};

export const spreadsheetsLoadManagers = createAsyncThunk(
  `${ns}/loadManagers`,
  async (_, { dispatch }) => {
    try {
      dispatch(spreadsheetsActions.setManagersLoading(true));
      const rdata = await getManagersList();
      dispatch(spreadsheetsActions.setManagersValue(rdata.managers));
    } catch (error: any) {
      console.error(error);
      spreadsheetsActions.setManagersError(error.message);
    } finally {
      dispatch(spreadsheetsActions.setManagersLoading(false));
    }
  }
)

export const spreadsheetsLoadApplications = createAsyncThunk(
  `${ns}/loadApplications`,
  async (
    {
      offset,
      limit,
      bin,
      compensation_type,
      signed_at_from,
      signed_at_until,
      company_name,
      application_no,
      application_year,
    }: {
      offset: number;
      limit: number;
      bin?: string;
      compensation_type?: string;
      signed_at_from?: string;
      signed_at_until?: string;
      company_name?: string;
      application_no?: number;
      application_year?: string;
    },
    { dispatch }
  ) => {
    try {
      dispatch(spreadsheetsActions.setApplicationsLoading(true));
      const rdata = await getSpreadshitsList({
        offset: offset,
        limit: limit,
        bin: bin,
        compensation_type: compensation_type,
        signed_at_from: signed_at_from,
        signed_at_until: signed_at_until,
        company_name: company_name,
        application_no: application_no,
        application_year: application_year,
      });
      const list = rdata.list;
      dispatch(
        spreadsheetsActions.setApplicationsValue({
          all_count: list.overall_count,
          applications: list.applications,
        })
      );
    } catch (error: any) {
      console.error(error);
    } finally {
      dispatch(spreadsheetsActions.setApplicationsLoading(false));
    }
  }
);

const spreadsheets = createSlice({
  name: ns,
  initialState: initialState,
  reducers: {
    setApplicationsValue: (state, action: PayloadAction<ISpreadsheets>) => {
      state.spreadsheets.value = action.payload;
    },
    setApplicationsLoading: (state, action: PayloadAction<boolean>) => {
      state.spreadsheets.loading = action.payload;
    },
    setApplicationsError: (state, action: PayloadAction<string>) => {
      state.spreadsheets.error = action.payload;
    },
    setManagersLoading: (state, action: PayloadAction<boolean>) => {
      state.managers.loading = action.payload;
    },
    setManagersValue: (state, action: PayloadAction<any[]>) => {
      state.managers.value = action.payload;
      const map = {}
      action.payload.forEach((item) => {
        map[item.user_id] = item;
      })
      state.managers.valueByUserID = map;
    },
    setManagersError: (state, action: PayloadAction<string>) => {
      state.managers.error = action.payload;
    }
  },
});

export const spreadsheetsActions = spreadsheets.actions;
export const spreadsheetsReducer = spreadsheets.reducer;
